module.exports = __webpack_public_path__ + "img/1-2.65a84da9.svg";